import {
  ChangeDetectionStrategy,
  Component,
  signal,
  inject,
} from '@angular/core';
import { KingService } from '../king.service';
import { KingQueueComponent } from '../king-queue/king-queue.component';
import { KingTimerComponent } from '../king-timer/king-timer.component';
import { KingSideTopComponent } from '../king-side-top/king-side-top.component';
import { KingSideBottomComponent } from '../king-side-bottom/king-side-bottom.component';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { GameIconComponent } from '../../../core/components/game-icon/game-icon.component';
import { ModalService } from '@features/modals/services/modal.service';
import { KingRowComponent } from '../king-row/king-row.component';
import { listAnimation } from '@core/utils/animations.util';

@Component({
  selector: 'app-king',
  templateUrl: './king.component.html',
  styleUrls: ['./king.component.scss'],
  standalone: true,
  imports: [
    KingQueueComponent,
    KingTimerComponent,
    KingSideTopComponent,
    KingSideBottomComponent,
    FairnessButtonComponent,
    GameIconComponent,
    KingRowComponent,
  ],
  animations: [listAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingComponent {
  hit = signal<boolean>(false);
  kingHit = signal<boolean>(false);

  public readonly kingService = inject(KingService);
  private readonly modalService = inject(ModalService);

  openDepositModal() {
    this.modalService.openModal('DepositKingModal');
  }
}
